import React from "react";

const App = () => {
  return <div>App</div>;
};

export default App;
